import { Link } from '@tanstack/react-router';
import { ProfileDropdown } from './profile-dropdown';
import { NotificationBell } from './notification-bell';

const items = [
  { to: '/', label: 'Home' },
  { to: '/achievements', label: 'Achievements' },
  { to: '/reward', label: 'Reward' },
  { to: '/history', label: 'History' },
] as const;

interface Props {
  bankedEnergy: number;
}

export function Nav({ bankedEnergy }: Props) {
  return (
    <nav className="sticky top-0 z-20 border-b border-border-soft bg-bg-raised/90 backdrop-blur">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3">
        <div className="flex items-center gap-6">
          <Link to="/" className="flex items-center gap-2">
            <span className="text-lg">🎮</span>
            <span className="font-pixel text-xs text-brand-400">LIFE.exe</span>
          </Link>
          <ul className="flex gap-5 text-sm">
            {items.map((i) => (
              <li key={i.to}>
                <Link
                  to={i.to}
                  activeProps={{ className: 'text-brand-400 font-medium' }}
                  className="text-neutral-400 hover:text-neutral-100 transition"
                >
                  {i.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="flex items-center gap-4">
          <EnergyBank energy={bankedEnergy} />
          <NotificationBell />
          <ProfileDropdown />
        </div>
      </div>
    </nav>
  );
}

function EnergyBank({ energy }: { energy: number }) {
  return (
    <div
      title="Enerji Bankası"
      className="flex items-center gap-2 rounded-full border border-time-500/40 bg-time-500/10 px-3 py-1 text-xs text-time-400"
    >
      <span>⚡</span>
      <span className="font-pixel text-[10px]">{energy}</span>
    </div>
  );
}

